import { MarketingDashboardSection } from "./sections/marketing-dashboard.section";

export const MarketingDashboardPage = () => <MarketingDashboardSection />;
